module.exports = __webpack_public_path__ + "static/media/5ed79b2f72f4e5e57a74877f.22ac18a2.png";